<script setup lang="ts">
import {PropType} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import Translator from "@/utils/common/Translator.ts";
import BusinessFunction from "@/utils/constants/BusinessFunction.ts";
import ApprovalUtils from "@/utils/editView/ApprovalUtils.ts";
import {SimpleEntityMenuItem} from "@/utils/UIConstants/MoreMenuItem.ts";
import DTOApprovalCase = namaTypes.DTOApprovalCase;

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});
const fieldValue = props.params.value;

async function approve() {
  let approvalCase: DTOApprovalCase = await NamaCommon.namaFetch(NamaURLS.Find_Approval_Case_By_Id, {params: {approvalCaseID: fieldValue}});
  if (approvalCase)
    await ApprovalUtils.showApprovalDialog(approvalCase);
}

async function show() {
  let approvalCase: DTOApprovalCase = await NamaCommon.namaFetch(NamaURLS.Find_Approval_Case_By_Id, {params: {approvalCaseID: fieldValue}});
  if (approvalCase)
    await SimpleEntityMenuItem.showCurrentApprovalCasePopup(approvalCase);
}
</script>

<template>
  <q-item v-if="fieldValue" dense class="tw-px-0 tw-w-full tw-h-full">
    <q-item-section>
      <div class="tw-flex tw-items-center tw-gap-2.5 tw-self-center">
        <NamaIcon :title="Translator.translateId(BusinessFunction.approval)" default-icon="nm-approve" class="tw-size-5 tw-cursor-pointer"
                  @click.stop="approve"/>
        <NamaIcon :title="Translator.translateId('showCurrentApproval')" default-icon="history" class="tw-size-5 tw-cursor-pointer"
                  @click.stop="show"/>
      </div>
    </q-item-section>
  </q-item>
</template>
